import {
  GET_LIST,
  GET_ONE,
  GET_MANY,
  GET_MANY_REFERENCE,
  CREATE,
  UPDATE,
  DELETE,
} from 'react-admin';
import { list, one, create, update, destroy } from './api';

export default (type, resource, params) => {
  let call = null;

  switch (type) {
    case GET_LIST:
    case GET_MANY:
    case GET_MANY_REFERENCE:
      call = list(resource, params);
      break;
    case GET_ONE:
      call = one(resource, params);
      break;
    case CREATE:
      call = create(resource, params);
      break;
    case UPDATE:
      call = update(resource, params);
      break;
    case DELETE:
      call = destroy(resource, params);
      break;
    default:
      throw new Error(`Unsupported Data Provider request type ${type}`);
  }

  return call.then(res => res.data);
};



// WEBPACK FOOTER //
// ./src/lib/dataProvider.js